const convertReliabilityScoreToDisplayValue = reliabilityScore => {
  const reliabilityScoreDisplay =
    typeof reliabilityScore === 'number' && !Number.isNaN(reliabilityScore)
      ? `${Math.round(reliabilityScore * 100)}%`
      : '--';
  return reliabilityScoreDisplay;
};

module.exports = { convertReliabilityScoreToDisplayValue };
